import React, { Component } from "react";
import { connect } from "react-redux";
import "../style.css";
import { withRouter } from "react-router-dom";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Style from "react-style-tag/lib/Style";
import { CircularProgress } from "@material-ui/core";
import { fetchDeliveryCharges } from "../../../store/actions/store";

class index extends Component {
  state = {
    search: "",
    originalLength: null,
  };
  myRef = React.createRef();
  executeScroll = () => {
    this.myRef.current.scrollTop += 56;
  };

  compare(a, b) {
    if (a.branch_sort_order < b.branch_sort_order) {
      return -1;
    }
    if (a.branch_sort_order > b.branch_sort_order) {
      return 1;
    }
    return 0;
  }

  componentDidMount = async () => {
    if (!this.props.fetchedDeliveryCharges) {
      await this.props.fetchDeliveryCharges(this.props.country_code);
    }
  };
  render() {
    const {
      language,
      themeColor,
      selectedPickupBranch,
      settings,
      fetchedDeliveryCharges,
    } = this.props;
    const { search, originalLength } = this.state;

    if (!fetchedDeliveryCharges) {
      return (
        <CircularProgress
          color="primary"
          style={{
            alignSelf: "center",
            justifySelf: "center",
            width: 30,
            height: 30,
          }}
        />
      );
    }
    let branches = this.props.branches.sort(this.compare);
    if (originalLength === null)
      this.setState({ originalLength: branches.length });
    if (!this.props.listOnly)
      branches = branches.filter(
        (b) => b.enable_pickup || !settings.is_branch_based_ordering
      );
    else branches = branches.filter((b) => !b.hide_branch);

    if (!branches?.length) return <></>;

    if (search)
      branches = branches.filter(
        (b) =>
          b.name.toLowerCase().includes(search.toLowerCase()) ||
          b.ar_name.toLowerCase().includes(search.toLowerCase()) ||
          b.id === selectedPickupBranch
      );

    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {this.props.listOnly ? (
            <span>{language === "arabic" ? "أفرعنا" : "Our branches"}</span>
          ) : (
            <span>
              {language == "arabic" ? "اختر المتجر" : "Choose a store"}{" "}
              {originalLength > 4 ? `(${branches.length})` : ""}
            </span>
          )}
        </p>

        {originalLength > 4 && (
          <>
            <Style>
              {`.MuiInput-underline:before {
                  border-bottom: 1px solid #dee2e6 !important;
              }`}
            </Style>
            <div
              style={{
                background: "white",
                borderBottom: "0px solid transparent",
              }}
              className="bordered"
            >
              {" "}
              <Input
                placeholder={language === "arabic" ? "ابحث ..." : "Search..."}
                inputProps={{ "aria-label": "search" }}
                style={{
                  width: "100%",
                  padding: "7px 9px",
                  direction: language === "arabic" ? "rtl" : "ltr",
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "grey" }} />
                  </InputAdornment>
                }
                onChange={(e) =>
                  this.setState({
                    search: e.target.value || "",
                  })
                }
              />
            </div>
          </>
        )}

        <div
          style={{
            height: "100%",
            direction: language == "english" ? "ltr" : "rtl",
            backgroundColor: "white",
            overflowY: "scroll",
          }}
          ref={this.myRef}
          className="w-100 bordered"
        >
          <List dense style={{ width: "100%" }}>
            {branches.map((branch) => {
              const labelId = `checkbox-list-secondary-label-${branch.id}`;
              const isSelected = selectedPickupBranch === branch.id;
              return (
                <>
                  <ListItem
                    key={Math.random() * 9999}
                    button
                    style={{
                      margin: "10px 0px 16px 0px",
                      [`border${language === "arabic" ? "Right" : "Left"}`]:
                        isSelected && `5px solid ${themeColor}`,
                      [`padding${
                        language === "arabic" ? "Left" : "Right"
                      }`]: 48,
                      [`padding${
                        language === "arabic" ? "Right" : "Left"
                      }`]: 16,
                      textAlign: language === "arabic" ? "right" : "left",
                    }}
                    onClick={() => {
                      if (!this.props.listOnly)
                        this.props.setSelectedPickupBranch(branch.id);
                      else
                        this.props.history.push(`/branch/${branch.id}`, {
                          fromContactPage: !!this.props.listOnly,
                        });
                    }}
                  >
                    <ListItemText
                      id={labelId}
                      primary={
                        <>
                          <div
                            style={{
                              marginBottom: 3,
                              padding: "0px 10px",
                              fontWeight: isSelected && "bold",
                              color: isSelected && themeColor,
                              fontSize: "1rem",
                            }}
                          >
                            {language === "arabic"
                              ? branch.ar_name || branch.name
                              : branch.name}
                          </div>
                          <div>
                            <Divider
                              style={{
                                position: "relative",
                                top: 8,
                              }}
                            />
                          </div>
                        </>
                      }
                    />
                    <ListItemSecondaryAction
                      style={{
                        [language === "arabic" ? "left" : "right"]: 16,
                        [language === "arabic" ? "right" : "left"]: "unset",
                      }}
                    >
                      {!branch.hide_branch && (
                        <HelpOutlineIcon
                          style={{
                            color: isSelected ? themeColor : "#7D7D7D",
                            fontSize: 20,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            this.props.history.push(`/branch/${branch.id}`, {
                              fromContactPage: !!this.props.listOnly,
                            })
                          }
                        />
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                </>
              );
            })}
          </List>
        </div>
        {/* {branches.length > 4 ? (
          <div
            className="text-center"
            style={{
              position: "relative",
              bottom: 21,
              background: "white",
              borderBottom: "1px solid #dee2e6",
            }}
            onClick={() => this.executeScroll()}
          >
            <KeyboardArrowDownIcon style={{ color: "#7D7D7D" }} />
          </div>
        ) : (
          <div style={{ marginBottom: 21, width: "100%" }}></div>
        )} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    countriesFullyLoaded: !state.store.thirdLoading,
    themeColor: state.store.store.settings.dark || "#0099cc",
    allow_only_pickup: state.cart.pickup_only_items > 0,
    auth: state.auth,
    branches: state.store.store.branches,
    settings: state.store.store.settings,
    fetchedDeliveryCharges: state.store.fetchedDeliveryCharges,
    country_code: state.store.store.country_code,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDeliveryCharges: (countryCode) =>
      dispatch(fetchDeliveryCharges(countryCode)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index));
